import { useAuth } from '@/context/AuthContext'

/**
 * Screen shown when a user's access has been disabled by admin.
 * Sign-in still works, but they see this instead of the app.
 */
export function BlockedAccess() {
  const { signOut } = useAuth()

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--color-kids-bg)] px-4">
      <div className="max-w-md w-full text-center">
        <div className="text-6xl mb-6">
          <span role="img" aria-label="paused">⏸️</span>
        </div>
        <h1 className="text-2xl font-bold text-[var(--color-kids-text)] mb-4">
          Access Paused
        </h1>
        <p className="text-[var(--color-kids-text-muted)] mb-8">
          Your account access has been temporarily paused. If you believe this is
          an error, please contact support.
        </p>
        <div className="space-y-4">
          <a
            href="mailto:support@inkwelljr.com"
            className="block w-full px-6 py-3 bg-[var(--color-kids-primary)] text-white rounded-xl font-semibold hover:opacity-90 transition-opacity"
          >
            Contact Support
          </a>
          <button
            onClick={() => signOut()}
            className="block w-full px-6 py-3 border-2 border-[var(--color-kids-border)] text-[var(--color-kids-text)] rounded-xl font-semibold hover:bg-[var(--color-kids-surface)] transition-colors"
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  )
}
